import { PubSub as PubSubCtor, TListener } from "@/browser";

import { TEventTopic } from "./types";

const PubSub = new PubSubCtor();

export const subscribe = (topic: TEventTopic, handler: TListener) => {
  return PubSub.subscribe(topic, handler);
};

export const subscribeOnce = (topic: TEventTopic, handler: TListener) => {
  return PubSub.subscribeOnce(topic, handler);
};

export const unsubscribe = (token: string) => {
  return PubSub.unsubscribe(token);
};

export const publish = (topic: TEventTopic, data?: any) => {
  return PubSub.publish(topic, data);
};
